import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { faultCodeConfig } from '../utils/texts';

interface FaultsProps {
  faults: string[];
}
export function Faults({ faults }: FaultsProps) {
  return (
    <>
      {faults.map((faultCode) => {
        const faultconfig = faultCodeConfig[faultCode];
        return (
          <OverlayTrigger
            key={faultCode}
            overlay={
              <Tooltip>
                {faultCode}
                <br />
                {faultconfig?.text}
              </Tooltip>
            }
          >
            <span className={`fault-item --${faultconfig?.color}`}>{faultconfig?.letter}</span>
          </OverlayTrigger>
        );
      })}
    </>
  );
}
